import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
const FileUploadProductC = ({ onUploadSuccess }) => {
  const [file, setFile] = useState(null);
  const [file2, setFile2] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [statusCC, setStatusCC] = useState(null);
  const [statusTF, setStatusTF] = useState(null);
  const [errorCodeCC, setErrorCodeCC] = useState(null);
  const [finalUpload, setFinalUpload] = useState(false);
  const [statusRes, setStatusRes] = useState(null);
  const [comNameEng, setComNameEng] = useState(null);
  const [comNameChi, setComNameChi] = useState(null);
  const [comBrNo, setComBrNo] = useState(null);
  const [registeredAddress, setRegisteredAddress] = useState(null);
  const [contactname, SetContactname] = useState(null);
  const [contactemailaddress, setContactemailaddress] = useState(null);
  const [bankName, setBankName] = useState(null);
  const [bankAccountNumber, setBankAccountNumber] = useState(null);
  const [beneficiaryName, setBeneficiaryName] = useState(null);
  const [bankCode, setBankCode] = useState(null);
  const [SWIFT, setSWIFT] = useState(null);
  const [contactNumber, setContactNumber] = useState(null);

  //   TF
  const [errorCodeTF, SetErrorCodeTF] = useState(null);
  const fileInputRef = useRef(null);
  const fileInputRef2 = useRef(null);
  const [purchaseComName, setPurchaseComName] = useState(null);
  const [rivrchainTRANSACTIONID, setRiverchainTRANSACTIONID] = useState(null);
  const [facilityLimit, setFacilityLimit] = useState(null);
  const [facilityAvailibilityDays, setFacilityAvailibilityDays] =
    useState(null);

  const [fundInUseLimit, setFundInUseLimit] = useState(null);
  const [discountingCharge, SetDiscountingCharge] = useState(null);
  const [availibilityFee, SetAvailibilityFee] = useState(null);
  const [interestRate, setInterestRate] = useState(null);
  const [additionalDisCharge, setAdditionalDisCharge] = useState(null);
  const [adminFee, setAdminFee] = useState(null);
  const [collectionFee, setCollectionFee] = useState(null);
  const [defaultInterestRate, setDefaultInterestRate] = useState(null);
  const [creditInsuranceFee, setCreditInsuranceFee] = useState(null);
  const [rebateRate, setRebateRate] = useState(null);
  const [paymentApplication, setPaymentApplication] = useState(null);
  const [paymentCert, setPaymentCert] = useState(null);
  const [maincontractDescription, setMaincontractDescription] = useState(null);
  const [underlyingDesc, setunderlyingDesc] = useState(null);
  const [contractStartDate, setContractStartDate] = useState(null);
  const [mainContractor, setMainContractor] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [debtorFundLimit, setDebtorFundLimit] = useState(null);
  const [maxTermDays, setMaxTermdays] = useState(null);

  const BACKEND_URL = "https://uat.atlas.docauto.riverchain.xyz";
  const API_URL = "https://uat.atlas.docauto.riverchain.xyz/api";

  function formatNewDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Ensure 2 digits
    const monthFull = date.toLocaleString("default", { month: "long" });
    const month = monthFull.slice(0, 3); // Take only the first 3 letters
    const year = date.getFullYear();

    return `${year} ${month} ${day}`;
  }

  function convertISOToDate(isoString) {
    if (typeof isoString !== "string") {
      throw new Error("Input must be a string");
    }

    const date = new Date(isoString);

    if (isNaN(date.getTime())) {
      throw new Error("Invalid date string provided");
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // JS months are 0-based
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  function formatNumberWithLeadingZeros(numInput) {
    const num = Number(numInput);

    if (!Number.isInteger(num) || num < 0 || num > 999) {
      throw new Error("Input must be an integer between 0 and 999");
    }

    if (num < 10) {
      return `00${num}`;
    } else if (num < 100) {
      return `0${num}`;
    } else {
      return `${num}`;
    }
  }

  const handleUploadCC = async () => {
    try {
      if (!file) {
        console.error("First file is missing!");
        setStatus("Please select the first file.");
        return false;
      }

      const formData1 = new FormData();
      formData1.append("file", file);

      console.log("Uploading first file...");
      const response = await fetch(`${BACKEND_URL}/uploadfile/`, {
        method: "POST",
        body: formData1,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
      const data = await response.json();
      console.log("First file uploaded successfully:", data);
      setErrorCodeCC(data?.content?.status);
      setComNameEng(
        data?.content?.CompanyName_English &&
          data?.content?.CompanyName_English !== null
          ? data?.content?.CompanyName_English
          : ""
      );

      setComNameChi(
        data?.content?.CompanyName_Chinese &&
          data?.content?.CompanyName_Chinese !== null
          ? data?.content?.CompanyName_Chinese
          : ""
      );

      setComBrNo(
        data?.content?.BusinessRegistrationNumber &&
          data?.content?.BusinessRegistrationNumber !== null
          ? data?.content?.BusinessRegistrationNumber
          : ""
      );

      setRegisteredAddress(
        data?.content?.RegisteredAddress &&
          data?.content?.RegisteredAddress !== null
          ? data?.content?.RegisteredAddress
          : ""
      );

      SetContactname(
        data?.content?.Contactname && data?.content?.Contactname !== null
          ? data?.content?.Contactname
          : ""
      );

      setContactemailaddress(
        data?.content?.Contactemailaddress &&
          data?.content?.Contactemailaddress !== null
          ? data?.content?.Contactemailaddress
          : ""
      );

      setBankName(
        data?.content?.BankName && data?.content?.BankName !== null
          ? data?.content?.BankName
          : ""
      );
      setBankAccountNumber(
        data?.content?.BankAccountNumber &&
          data?.content?.BankAccountNumber !== null
          ? data?.content?.BankAccountNumber
          : ""
      );

      setBeneficiaryName(
        data?.content?.BeneficiaryName &&
          data?.content?.BeneficiaryName !== null
          ? data?.content?.BeneficiaryName
          : ""
      );
      setBankCode(
        data?.content?.BankCode && data?.content?.BankCode !== null
          ? formatNumberWithLeadingZeros(data?.content?.BankCode)
          : ""
      );

      setSWIFT(
        data?.content?.SWIFT && data?.content?.SWIFT !== null
          ? data?.content?.SWIFT
          : ""
      );

      setContactNumber(
        data?.content?.Contactphonenumber &&
          data?.content?.Contactphonenumber !== null
          ? data?.content?.Contactphonenumber
          : ""
      );

      return true;
    } catch (error) {
      console.error("Error uploading first file:", error);
      setStatus("Error uploading first file. Check console for details.");
      return false;
    }
  };

  const handleUploadTF = async () => {
    try {
      if (!file2) {
        console.error("Second file is missing!");
        setStatus("Please select the second file.");
        return;
      }
      const formData2 = new FormData();
      formData2.append("file", file2);

      console.log("Uploading second file...");

      const response = await fetch(`${BACKEND_URL}/uploadCCTFPRODCfile/`, {
        method: "POST",
        body: formData2,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
      const data = await response.json();
      console.log("Second file uploaded successfully:", data);

      SetErrorCodeTF(data?.contentTF?.status);

      setPurchaseComName(
        data?.contentTF?.LENDER_PURCHASER &&
          data?.contentTF?.LENDER_PURCHASER !== null
          ? data?.contentTF?.LENDER_PURCHASER
          : ""
      );

      setRiverchainTRANSACTIONID(
        data?.contentTF?.TRANSACTIONID &&
          data?.contentTF?.TRANSACTIONID !== null
          ? data?.contentTF?.TRANSACTIONID
          : ""
      );
      setFacilityLimit(
        data?.contentTF?.PRODUCT_DETAILS?.FACILITY_PREPAYMENTLIMIT &&
          data?.contentTF?.PRODUCT_DETAILS?.FACILITY_PREPAYMENTLIMIT !== null
          ? data?.contentTF?.PRODUCT_DETAILS?.FACILITY_PREPAYMENTLIMIT
          : ""
      );

      setFacilityAvailibilityDays(
        data?.contentTF?.PRODUCT_DETAILS?.FACILITYAVAILABILITYPERIOD_MONTHS &&
          data?.contentTF?.PRODUCT_DETAILS
            ?.FACILITYAVAILABILITYPERIOD_MONTHS !== null
          ? data?.contentTF?.PRODUCT_DETAILS?.FACILITYAVAILABILITYPERIOD_MONTHS
          : ""
      );

      setFundInUseLimit(
        data?.contentTF?.PRODUCT_DETAILS?.FUNDSINUSELIMIT &&
          data?.contentTF?.PRODUCT_DETAILS?.FUNDSINUSELIMIT === null
          ? ""
          : data?.contentTF?.PRODUCT_DETAILS?.FUNDSINUSELIMIT === "n/a"
          ? ""
          : data?.contentTF?.PRODUCT_DETAILS?.FUNDSINUSELIMIT
      );

      console.log("*******************");
      console.log(fundInUseLimit);

      SetDiscountingCharge(
        data?.contentTF?.PRODUCT_DETAILS
          ?.GRACEPERIODBEFOREANYADDITIONALDISCOUNTINGCHARGE &&
          data?.contentTF?.PRODUCT_DETAILS
            ?.GRACEPERIODBEFOREANYADDITIONALDISCOUNTINGCHARGE !== null
          ? data?.contentTF?.PRODUCT_DETAILS
              ?.GRACEPERIODBEFOREANYADDITIONALDISCOUNTINGCHARGE
          : ""
      );

      SetAvailibilityFee(
        data?.contentTF?.PRODUCT_DETAILS?.AVAILABILITYFEE &&
          data?.contentTF?.PRODUCT_DETAILS?.AVAILABILITYFEE !== null
          ? data?.contentTF?.PRODUCT_DETAILS?.AVAILABILITYFEE
          : ""
      );
      setInterestRate(
        data?.contentTF?.PRODUCT_DETAILS
          ?.INTERESTRATE_DISCOUNTCHARGE__PERCENTAGE_PA &&
          data?.contentTF?.PRODUCT_DETAILS
            ?.INTERESTRATE_DISCOUNTCHARGE__PERCENTAGE_PA !== null
          ? data?.contentTF?.PRODUCT_DETAILS
              ?.INTERESTRATE_DISCOUNTCHARGE__PERCENTAGE_PA * 100
          : ""
      );
      setAdditionalDisCharge(
        data?.contentTF?.PRODUCT_DETAILS
          ?.OVERDUECHARGE__PERCENTAGE__ADDITIONALDISCOUNTCHARGE_FACTORING_PERCENTAGE_ &&
          data?.contentTF?.PRODUCT_DETAILS
            ?.OVERDUECHARGE__PERCENTAGE__ADDITIONALDISCOUNTCHARGE_FACTORING_PERCENTAGE_ !==
            null
          ? data?.contentTF?.PRODUCT_DETAILS
              ?.OVERDUECHARGE__PERCENTAGE__ADDITIONALDISCOUNTCHARGE_FACTORING_PERCENTAGE_ *
              100
          : ""
      );
      setAdminFee(
        data?.contentTF?.PRODUCT_DETAILS?.ADMINFEE__PERCENTAGE_ &&
          data?.contentTF?.PRODUCT_DETAILS?.ADMINFEE__PERCENTAGE_ !== null
          ? (
              data?.contentTF?.PRODUCT_DETAILS?.ADMINFEE__PERCENTAGE_ * 100
            ).toFixed(2)
          : ""
      );

      setCollectionFee(
        data?.contentTF?.PRODUCT_DETAILS?.COLLECTIONACCOUNTFEE &&
          data?.contentTF?.PRODUCT_DETAILS?.COLLECTIONACCOUNTFEE !== null
          ? data?.contentTF?.PRODUCT_DETAILS?.COLLECTIONACCOUNTFEE
          : ""
      );

      setDefaultInterestRate(
        data?.contentTF?.PRODUCT_DETAILS?.DEFAULTINTERESTRATE_PERCENTAGE_ &&
          data?.contentTF?.PRODUCT_DETAILS?.DEFAULTINTERESTRATE_PERCENTAGE_ !==
            null
          ? data?.contentTF?.PRODUCT_DETAILS?.DEFAULTINTERESTRATE_PERCENTAGE_ *
              100
          : ""
      );

      setCreditInsuranceFee(
        data?.contentTF?.PRODUCT_DETAILS?.CREDITINSURANCEFEE &&
          data?.contentTF?.PRODUCT_DETAILS?.CREDITINSURANCEFEE !== null
          ? data?.contentTF?.PRODUCT_DETAILS?.CREDITINSURANCEFEE
          : ""
      );

      setRebateRate(
        data?.contentTF?.PRODUCT_DETAILS?.REBATERATE__PERCENTAGE_ &&
          data?.contentTF?.PRODUCT_DETAILS?.REBATERATE__PERCENTAGE_ !== null
          ? data?.contentTF?.PRODUCT_DETAILS?.REBATERATE__PERCENTAGE_
          : ""
      );

      setPaymentApplication(
        data?.contentTF?.PRODUCT_DETAILS?.PAYMENTAPPLICATION_IFANY &&
          data?.contentTF?.PRODUCT_DETAILS?.PAYMENTAPPLICATION_IFANY !== null
          ? data?.contentTF?.PRODUCT_DETAILS?.PAYMENTAPPLICATION_IFANY
          : "0"
      );

      setPaymentCert(
        data?.contentTF?.PRODUCT_DETAILS?.INVOICE_PAYMENTCERT &&
          data?.contentTF?.PRODUCT_DETAILS?.INVOICE_PAYMENTCERT !== null
          ? data?.contentTF?.PRODUCT_DETAILS?.INVOICE_PAYMENTCERT * 100
          : ""
      );

      setMaincontractDescription(
        data?.contentTF?.CONTRACT?.MAINCONTRACTDESCRIPTION &&
          data?.contentTF?.CONTRACT?.MAINCONTRACTDESCRIPTION !== null
          ? data?.contentTF?.CONTRACT?.MAINCONTRACTDESCRIPTION
          : ""
      );

      setunderlyingDesc(
        data?.contentTF?.CONTRACT?.UNDERLYINGCONTRACTDESCRIPTION &&
          data?.contentTF?.CONTRACT?.UNDERLYINGCONTRACTDESCRIPTION !== null
          ? data?.contentTF?.CONTRACT?.UNDERLYINGCONTRACTDESCRIPTION
          : ""
      );

      setContractStartDate(
        data?.contentTF?.CONTRACT?.CONTRACTSTARTDATE &&
          data?.contentTF?.CONTRACT?.CONTRACTSTARTDATE !== null
          ? data?.contentTF?.CONTRACT?.CONTRACTSTARTDATE
          : ""
      );

      console.log("************");
      console.log(contractStartDate);

      setMainContractor(
        data?.contentTF?.CONTRACT?.MAINCONTRACTOR_ORDEBTOR &&
          data?.contentTF?.CONTRACT?.MAINCONTRACTOR_ORDEBTOR !== null
          ? data?.contentTF?.CONTRACT?.MAINCONTRACTOR_ORDEBTOR
          : ""
      );

      console.log("***************");
      console.log(mainContractor);

      setCurrency(
        data?.contentTF?.PRODUCT_DETAILS?.CURRENCY &&
          data?.contentTF?.PRODUCT_DETAILS?.CURRENCY !== null
          ? data?.contentTF?.PRODUCT_DETAILS?.CURRENCY
          : ""
      );

      setDebtorFundLimit(
        data?.contentTF?.PRODUCT_DETAILS?.FACILITY_PREPAYMENTLIMIT &&
          data?.contentTF?.PRODUCT_DETAILS?.FACILITY_PREPAYMENTLIMIT !== null
          ? data?.contentTF?.PRODUCT_DETAILS?.FACILITY_PREPAYMENTLIMIT
          : ""
      );

      setMaxTermdays(
        data?.contentTF?.PRODUCT_DETAILS?.MAXTERMOFPAYMENT_DAYS &&
          data?.contentTF?.PRODUCT_DETAILS?.MAXTERMOFPAYMENT_DAYS !== null
          ? data?.contentTF?.PRODUCT_DETAILS?.MAXTERMOFPAYMENT_DAYS
          : ""
      );

      return true;
    } catch (error) {
      console.error("Error uploading second file:", error);
      setStatus("Upload failed, please check the uploaded file");
    }
  };

  const handleUpload = async () => {
    if (!file || !file2) {
      setStatus("Please select both files before uploading.");
      return;
    }
    setLoading(true);
    setStatus("Uploading first file...");

    if (errorCodeCC === "ERROR") {
      // setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    if (errorCodeTF === "ERROR") {
      // setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    const firstFileSuccess = await handleUploadCC();

    if (firstFileSuccess) {
      console.log("First upload successful, now uploading second file...");
      setStatus("Uploading second file...");
      setFinalUpload(true);
      await handleUploadTF();
    } else {
      console.log("First upload failed, skipping second upload.");
    }

    setLoading(false);
  };

  useEffect(() => {
    if (errorCodeCC === "ERROR") {
      // setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    if (errorCodeTF === "ERROR") {
      // setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    if (errorCodeCC === "OK" && errorCodeTF === "OK") {
      var newPurchaserName;
      if (purchaseComName === "Riverchain One Limited") {
        newPurchaserName = "9949";
      } else if (purchaseComName === "River Square Company Limited") {
        newPurchaserName = "9950";
      } else if (purchaseComName === "AR Horizon Limited") {
        newPurchaserName = "9951";
      }

      var newContractStartdate = convertISOToDate(contractStartDate);
      console.log("New date");
      console.log(newContractStartdate);

      const xmlData = `<?xml version="1.0" encoding="UTF-8"?>
<isheet recordcount="string">
	<id>0</id>
	<title>string</title>
	<description>string</description>
	<status>string</status>
	<accesstype>string</accesstype>
	<type>string</type>
	<viewlink>string</viewlink>
	<allowsections>string</allowsections>
	<allowlookup>string</allowlookup>
	<displayisheet>string</displayisheet>
	<searchasdefaultview>string</searchasdefaultview>
	<enableversion>string</enableversion>
	<enablesheetalerter>string</enablesheetalerter>
	<alertercondition>string</alertercondition>
	<overrideitemmodifieddate>string</overrideitemmodifieddate>
	<enablebulkinsertupdate>string</enablebulkinsertupdate>
	<fielddescriptions>string</fielddescriptions>
	<enablerowlocking>string</enablerowlocking>
	<setcharlimittruncatemultilinetextenabled>string</setcharlimittruncatemultilinetextenabled>
	<setcharlimittruncatemultilinetextval>string</setcharlimittruncatemultilinetextval>
	<allowchoicelistvaluesforreuse>string</allowchoicelistvaluesforreuse>
	<allowscorelistvaluesforreuse>string</allowscorelistvaluesforreuse>
	<allowIsheetComments>string</allowIsheetComments>
	<shareRecordsLimit>0</shareRecordsLimit>
	<shareRecordsLimitEnabled>0</shareRecordsLimitEnabled>
	<enableIsheetAddRecordFormSharing>string</enableIsheetAddRecordFormSharing>
	<allowViewBaseRendering>string</allowViewBaseRendering>
	<columns>
		<column sequence="string" attributecolumnid="290">
			<columnid>0</columnid>
			<name>test</name>
			<type>0</type>
			<status>0</status>
			<systemgeneratedtype>string</systemgeneratedtype>
			<section>0</section>
			<description>string</description>
			<addtodefaultview>string</addtodefaultview>
			<columnconditionstate>string</columnconditionstate>
			<columnconditions>
				<row>
					<rowid>0</rowid>
					<columnid>0</columnid>
					<operatorid>0</operatorid>
					<oprand>string</oprand>
					<userlookupfilters>
						<userlookupfilter>
							<oprand>string</oprand>
							<userlookuptype>string</userlookuptype>
						</userlookupfilter>
					</userlookupfilters>
					<logicaltype>string</logicaltype>
					<sheetfiltervaluetypeid>string</sheetfiltervaluetypeid>
					<displaytype>string</displaytype>
					<scoreConditionTypeid>0</scoreConditionTypeid>
					<sourceColumnId>0</sourceColumnId>
				</row>
			</columnconditions>
			<columnspecificdetail>
				<defaultvalue>string</defaultvalue>
				<columnwidth>string</columnwidth>
				<sheetname>string</sheetname>
				<sitename>string</sitename>
				<mandatory>string</mandatory>
				<allowsearch>string</allowsearch>
				<maxchars>0</maxchars>
				<allowfieldfromanotherisheet>string</allowfieldfromanotherisheet>
				<allowrichhtmltext>string</allowrichhtmltext>
				<numberoflines>0</numberoflines>
				<displaymethod>string</displaymethod>
				<includeotheroption>string</includeotheroption>
				<singleormultileselectioninsearch>string</singleormultileselectioninsearch>
				<choices>
					<choice>
						<id>string</id>
						<label>string</label>
						<score>string</score>
						<color>string</color>
						<imageid>0</imageid>
					</choice>
				</choices>
				<includeinalertpreferences>string</includeinalertpreferences>
				<min>string</min>
				<max>string</max>
				<decimalplaces>0</decimalplaces>
				<showthousandseparators>string</showthousandseparators>
				<showaspercentage>string</showaspercentage>
				<symbolId>string</symbolId>
				<numberDecimalFormat>DOT_AS_DECIMAL/COMMA_AS_DECIMAL</numberDecimalFormat>
				<symbolPosition>before/after</symbolPosition>
				<formattype>string</formattype>
				<dateformat>string</dateformat>
				<defaultdateandtime>string</defaultdateandtime>
				<sheetlookup>string</sheetlookup>
				<fielddisplay>string</fielddisplay>
				<allowmultipleusers>string</allowmultipleusers>
				<methodtype>string</methodtype>
				<sheetids>string</sheetids>
				<allowuserstorenamelinks>string</allowuserstorenamelinks>
				<sheetid>0</sheetid>
				<columnids>string</columnids>
				<viewid>0</viewid>
				<allowmultiplevalues>string</allowmultiplevalues>
				<restrictdelete>string</restrictdelete>
				<displaycolumnnameprefix>string</displaycolumnnameprefix>
				<linkname>string</linkname>
				<donotcountweekendsonlycountmontofri>string</donotcountweekendsonlycountmontofri>
				<joinconditions>
					<joincondition>
						<currentsheetcolumnid>0</currentsheetcolumnid>
						<targetsheetcolumnid>0</targetsheetcolumnid>
					</joincondition>
				</joinconditions>
				<formula>string</formula>
				<startvalue>0</startvalue>
				<prefix>string</prefix>
				<postfix>string</postfix>
				<minlength>0</minlength>
				<lookupglossarysheetid>0</lookupglossarysheetid>
				<lookupglossarysheetviewid>0</lookupglossarysheetviewid>
				<width>0</width>
				<otherscorevalue>string</otherscorevalue>
				<importdatafromexternalsource>string</importdatafromexternalsource>
				<analysisengine>string</analysisengine>
				<attachmentcustomfolderid>0</attachmentcustomfolderid>
				<singleLineEmailValidation>string</singleLineEmailValidation>
				<readonly>string</readonly>
				<virtualColumn>0</virtualColumn>
				<externalSource>string</externalSource>
				<allowInlineEditing>string</allowInlineEditing>
			</columnspecificdetail>
			<rawdata>
				<value>string</value>
				<choices>
					<choice>
						<id>string</id>
						<label>string</label>
						<score>string</score>
						<color>string</color>
						<imageid>0</imageid>
					</choice>
				</choices>
				<date>string</date>
				<time>string</time>
				<linkdisplayname>string</linkdisplayname>
				<linkdisplayurl>string</linkdisplayurl>
				<lookups>
					<lookup>
						<id>string</id>
						<email>string</email>
						<userlookuptype>string</userlookuptype>
					</lookup>
				</lookups>
				<folders>
					<folder>
						<folderid>string</folderid>
					</folder>
				</folders>
				<documents>
					<document>
						<docid>string</docid>
					</document>
				</documents>
				<fromdate>string</fromdate>
				<todate>string</todate>
				<attachments>
					<attachment>
						<file>string</file>
						<name>string</name>
						<order>string</order>
						<id>0</id>
						<extension>string</extension>
						<parentfolderid>0</parentfolderid>
						<filehttplink>string</filehttplink>
						<folderpath>string</folderpath>
						<folderhttplink>string</folderhttplink>
						<filesize>0</filesize>
						<redactionstatus>true</redactionstatus>
						<siteid>0</siteid>
						<displayname>string</displayname>
					</attachment>
				</attachments>
				<isheetitems>
					<isheetitem>
						<recordid>string</recordid>
						<linkname>string</linkname>
						<apilink>string</apilink>
						<httplink>string</httplink>
					</isheetitem>
				</isheetitems>
				<daydifference>string</daydifference>
			</rawdata>
			<colViewPosition>0</colViewPosition>
			<columntype>string</columntype>
			<createdDate>2025-02-17T09:13:44.900Z</createdDate>
			<modifiedDate>2025-02-17T09:13:44.900Z</modifiedDate>
			<injectReferenceColumn>0</injectReferenceColumn>
			<parentColumnID>0</parentColumnID>
			<reusecolumnidfromisheet>0</reusecolumnidfromisheet>
			<choicelistid>0</choicelistid>
			<editpermission>0</editpermission>
			<templatesheetcolumnid>0</templatesheetcolumnid>
			<uploadpermission>0</uploadpermission>
			<deletepermission>0</deletepermission>
			<sourceSheetID>0</sourceSheetID>
		</column>
	</columns>
	<metadata>
		<siteName>string</siteName>
		<siteId>0</siteId>
		<sheetId>0</sheetId>
		<viewId>0</viewId>
		<viewName>string</viewName>
		<sheetName>string</sheetName>
	</metadata>
    <head>
      <headcolumn sequence="1" columntypealias="SHEET_COLUMN_TYPE_LOOKUP" columntypeid="6" columnid="1142">
        <columnvalue><![CDATA[Created by]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="2" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="1143">
        <columnvalue><![CDATA[Created date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="3" columntypealias="SHEET_COLUMN_TYPE_LOOKUP" columntypeid="6" columnid="1144">
        <columnvalue><![CDATA[Modified by]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="4" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="1145">
        <columnvalue><![CDATA[Modified date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="5" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1146">
        <columnvalue><![CDATA[Client Name English]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="6" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1147">
        <columnvalue><![CDATA[Client Name Chinese]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="7" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1148">
        <columnvalue><![CDATA[Client BR No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="8" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1149">
        <columnvalue><![CDATA[Client place of incorporation]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="9" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1150">
        <columnvalue><![CDATA[Client Address]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="10" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1151">
        <columnvalue><![CDATA[Client Contact Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="11" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1153">
        <columnvalue><![CDATA[Client Contact Email]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="12" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1154">
        <columnvalue><![CDATA[Riverchain ID]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="13" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="1155">
        <columnvalue><![CDATA[Purchase Company Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="14" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1156">
        <columnvalue><![CDATA[Purchaser Signor Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="15" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1157">
        <columnvalue><![CDATA[Purchaser Signor Title]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="16" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1158">
        <columnvalue><![CDATA[Prepayment Limit]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="17" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="1160">
        <columnvalue><![CDATA[Availability Period Date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="18" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1161">
        <columnvalue><![CDATA[Availability Period (Month)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="19" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1162">
        <columnvalue><![CDATA[FIU Limit]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="20" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1163">
        <columnvalue><![CDATA[Concentration Percentage]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="21" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1164">
        <columnvalue><![CDATA[Grace Period before additional discounting (days)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="22" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1165">
        <columnvalue><![CDATA[Availability Fee]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="23" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1166">
        <columnvalue><![CDATA[Discount Rate (%)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="24" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1167">
        <columnvalue><![CDATA[Additional Discount Rate (%)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="25" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1168">
        <columnvalue><![CDATA[Admin Fee (%)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="26" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1169">
        <columnvalue><![CDATA[Collection Account Fee]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="27" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1170">
        <columnvalue><![CDATA[Fee payment days]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="28" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1171">
        <columnvalue><![CDATA[Default Interest Rate (%)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="29" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1172">
        <columnvalue><![CDATA[Credit Insurance Fee]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="30" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1173">
        <columnvalue><![CDATA[Rebate Rate (%)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="31" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1174">
        <columnvalue><![CDATA[Client Bank Account Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="32" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1175">
        <columnvalue><![CDATA[Client Bank Acount No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="33" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1176">
        <columnvalue><![CDATA[Client Bank Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="34" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1177">
        <columnvalue><![CDATA[Client Bank Code]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="35" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1178">
        <columnvalue><![CDATA[Client Bank Swift Code]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="36" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1179">
        <columnvalue><![CDATA[Debtor Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="37" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1180">
        <columnvalue><![CDATA[Debtor Fund Limit]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="38" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1181">
        <columnvalue><![CDATA[Debtor Prepayment Percentage (Payment App)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="39" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1182">
        <columnvalue><![CDATA[Debtor Prepayment Percentage (Payment Cert)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="40" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1183">
        <columnvalue><![CDATA[Project Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="41" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1184">
        <columnvalue><![CDATA[Project Details]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="42" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="1185">
        <columnvalue><![CDATA[Project Contract Date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="43" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1186">
        <columnvalue><![CDATA[Project Main Contractor]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="44" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1187">
        <columnvalue><![CDATA[Credit cover limit]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="45" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1188">
        <columnvalue><![CDATA[Credit cover percentage]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="46" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="1189">
        <columnvalue><![CDATA[Credit cover limit expiry date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="47" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1190">
        <columnvalue><![CDATA[Debtor Prepayment Percentage (Other Evidence of Debt)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="48" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1191">
        <columnvalue><![CDATA[Maximum extension period (days)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="49" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1192">
        <columnvalue><![CDATA[Maximum invoicing period (days)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="50" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1193">
        <columnvalue><![CDATA[First Loss]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="51" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1194">
        <columnvalue><![CDATA[Evidence of Debt]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="52" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1195">
        <columnvalue><![CDATA[Debtor Address]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="53" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1196">
        <columnvalue><![CDATA[Debtor reference number]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="54" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="1197">
        <columnvalue><![CDATA[Max Term (Days)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="55" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="1201">
        <columnvalue><![CDATA[Currency]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="56" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1203">
        <columnvalue><![CDATA[Client Contact No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="57" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1204">
        <columnvalue><![CDATA[Attorney Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="58" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1205">
        <columnvalue><![CDATA[Attorney BR No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="59" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1206">
        <columnvalue><![CDATA[Attorney Place of Incorporation]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="60" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1207">
        <columnvalue><![CDATA[Attorney Address]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="61" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="1208">
        <columnvalue><![CDATA[POA Specific Date]]></columnvalue>
      </headcolumn>
    </head>

	<data>
		<item externalid="" itemsequence="1" itemid="1">
			<column sequence="5" attributecolumnid="1146">
                <rawdata>
                    <value><![CDATA[${comNameEng}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${comNameEng}]]></value>
                </displaydata>
            </column>
            <column sequence="6" attributecolumnid="1147">
                <rawdata>
                    <value><![CDATA[${comNameChi}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${comNameChi}]]></value>
                </displaydata>
            </column>
            <column sequence="7" attributecolumnid="1148">
                <rawdata>
                    <value><![CDATA[${comBrNo}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${comBrNo}]]></value>
                </displaydata>
            </column>
            <column sequence="9" attributecolumnid="1150">
                <rawdata>
                    <value><![CDATA[${registeredAddress}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${registeredAddress}]]></value>
                </displaydata>
            </column>
             <column sequence="10" attributecolumnid="1151">
                <rawdata>
                    <value><![CDATA[${contactname}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${contactname}]]></value>
                </displaydata>
            </column>
            <column sequence="11" attributecolumnid="1153">
                <rawdata>
                    <value><![CDATA[${contactemailaddress}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${contactemailaddress}]]></value>
                </displaydata>
            </column>
            <column sequence="12" attributecolumnid="1154">
                <rawdata>
                    <value><![CDATA[${rivrchainTRANSACTIONID}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${rivrchainTRANSACTIONID}]]></value>
                </displaydata>
            </column>
            <column sequence="14" attributecolumnid="1155">
                <rawdata>
                        <choices>
                            <choice>
                                    <id>${newPurchaserName}</id>
                            </choice>
                        </choices>
                    </rawdata>
            </column>
            <column sequence="16" attributecolumnid="1158">
                <rawdata>
                    <value><![CDATA[${facilityLimit}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${facilityLimit}]]></value>
                </displaydata>
            </column>
            <column sequence="17" attributecolumnid="1160">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="18" attributecolumnid="1161">
                <rawdata>
                    <value><![CDATA[${facilityAvailibilityDays}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${facilityAvailibilityDays}]]></value>
                </displaydata>
            </column>
            <column sequence="19" attributecolumnid="1162">
                <rawdata>
                    <value><![CDATA[${fundInUseLimit}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${fundInUseLimit}]]></value>
                </displaydata>
            </column>
            <column sequence="20" attributecolumnid="1163">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="21" attributecolumnid="1164">
                <rawdata>
                    <value><![CDATA[${discountingCharge}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${discountingCharge}]]></value>
                </displaydata>
            </column>
             <column sequence="22" attributecolumnid="1165">
                <rawdata>
                    <value><![CDATA[${availibilityFee}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${availibilityFee}]]></value>
                </displaydata>
            </column>
            <column sequence="23" attributecolumnid="1166">
                <rawdata>
                    <value><![CDATA[${interestRate}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${interestRate}]]></value>
                </displaydata>
            </column>
             <column sequence="24" attributecolumnid="1167">
                <rawdata>
                    <value><![CDATA[${additionalDisCharge}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${additionalDisCharge}]]></value>
                </displaydata>
            </column>
            <column sequence="25" attributecolumnid="1168">
                <rawdata>
                    <value><![CDATA[${adminFee}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${adminFee}]]></value>
                </displaydata>
            </column>
            <column sequence="26" attributecolumnid="1169">
                <rawdata>
                    <value><![CDATA[${collectionFee}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${collectionFee}]]></value>
                </displaydata>
            </column>
            <column sequence="27" attributecolumnid="1170">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="28" attributecolumnid="1171">
                <rawdata>
                    <value><![CDATA[${defaultInterestRate}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${defaultInterestRate}]]></value>
                </displaydata>
            </column>
            <column sequence="29" attributecolumnid="1172">
                <rawdata>
                    <value><![CDATA[${creditInsuranceFee}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${creditInsuranceFee}]]></value>
                </displaydata>
            </column>
            <column sequence="30" attributecolumnid="1173">
                <rawdata>
                    <value><![CDATA[${rebateRate}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${rebateRate}]]></value>
                </displaydata>
            </column>
            <column sequence="31" attributecolumnid="1174">
                <rawdata>
                    <value><![CDATA[${beneficiaryName}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${beneficiaryName}]]></value>
                </displaydata>
            </column>
            <column sequence="32" attributecolumnid="1175">
                <rawdata>
                    <value><![CDATA[${bankAccountNumber}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${bankAccountNumber}]]></value>
                </displaydata>
            </column>
            <column sequence="33" attributecolumnid="1176">
                <rawdata>
                    <value><![CDATA[${bankName}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${bankName}]]></value>
                </displaydata>
            </column>
            <column sequence="61" attributecolumnid="1224">
                <rawdata>
                    <value><![CDATA[${bankCode}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${bankCode}]]></value>
                </displaydata>
            </column>
            <column sequence="35" attributecolumnid="1178">
                <rawdata>
                    <value><![CDATA[${SWIFT}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${SWIFT}]]></value>
                </displaydata>
            </column>
            <column sequence="36" attributecolumnid="1179">
                <rawdata>
                    <value><![CDATA[${mainContractor}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${mainContractor}]]></value>
                </displaydata>
            </column>
            <column sequence="37" attributecolumnid="1180">
                <rawdata>
                    <value><![CDATA[${debtorFundLimit}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${debtorFundLimit}]]></value>
                </displaydata>
            </column>
            <column sequence="38" attributecolumnid="1181">
                <rawdata>
                    <value><![CDATA[${paymentApplication}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${paymentApplication}]]></value>
                </displaydata>
            </column>
            <column sequence="39" attributecolumnid="1182">
                <rawdata>
                    <value><![CDATA[${paymentCert}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${paymentCert}]]></value>
                </displaydata>
            </column>
            <column sequence="40" attributecolumnid="1183">
                <rawdata>
                    <value><![CDATA[${maincontractDescription}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${maincontractDescription}]]></value>
                </displaydata>
            </column>
            <column sequence="41" attributecolumnid="1184">
                <rawdata>
                    <value><![CDATA[${underlyingDesc}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${underlyingDesc}]]></value>
                </displaydata>
            </column>
            <column sequence="42" attributecolumnid="1185">
                <rawdata>
                    <value><![CDATA[${newContractStartdate}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${newContractStartdate}]]></value>
                </displaydata>
            </column>
            <column sequence="43" attributecolumnid="1186">
                <rawdata>
                    <value><![CDATA[${mainContractor}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${mainContractor}]]></value>
                </displaydata>
            </column>
            <column sequence="44" attributecolumnid="1187">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="45" attributecolumnid="1187">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="46" attributecolumnid="1188">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="47" attributecolumnid="1189">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
             <column sequence="48" attributecolumnid="1190">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
             <column sequence="49" attributecolumnid="1191">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="50" attributecolumnid="1192">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="51" attributecolumnid="1193">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="52" attributecolumnid="1194">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="53" attributecolumnid="1195">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="54" attributecolumnid="1196">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="55" attributecolumnid="1197">
                <rawdata>
                    <value><![CDATA[${maxTermDays}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${maxTermDays}]]></value>
                </displaydata>
            </column>
            <column sequence="55" attributecolumnid="1201">
                <rawdata>
                    <value><![CDATA[${currency}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${currency}]]></value>
                </displaydata>
            </column>
            <column sequence="56" attributecolumnid="1203">
                <rawdata>
                    <value><![CDATA[${contactNumber}]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[${contactNumber}]]></value>
                </displaydata>
            </column>
            <column sequence="57" attributecolumnid="1204">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="58" attributecolumnid="1205">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="59" attributecolumnid="1206">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
            <column sequence="60" attributecolumnid="1207">
                <rawdata>
                    <value><![CDATA[]]></value>
                </rawdata>
                <displaydata>
                    <value><![CDATA[]]></value>
                </displaydata>
            </column>
      </item>
	</data>
	<sheettypeid>0</sheettypeid>
	<enablesmartform>string</enablesmartform>
	<allowDeletedItemsView>string</allowDeletedItemsView>
	<allowAllColumnsInCustomView>string</allowAllColumnsInCustomView>
</isheet>`;

      const postData = async () => {
        try {
          const res = await axios.post(`${API_URL}/postc`, xmlData, {
            headers: {
              "Content-Type": "application/xml",
            },
          });

          console.log("Response_data:", res.data.progressivekey);
          setStatus("iSheet successfully generated");

          console.log(xmlData);
          setStatusRes(res.data?.progressivekey);
          onUploadSuccess();
          setTimeout(() => {
            setStatus(null);
          }, 5000);
          removeFile();
          removeFile2();
        } catch (error) {
          console.error("Error sending data:", error);
        }
      };

      postData();
    }
  }, [finalUpload]);

  const handleFile1Change = (e) => {
    const selectedFile = e.target.files[0];
    console.log("selectedFile:", selectedFile);
    if (selectedFile) {
      setFile(selectedFile);
      setStatusCC(null);
    }
  };

  const isRemovingRef = useRef(false);
  const isRemovingRef2 = useRef(false);

  const removeFile = () => {
    isRemovingRef.current = true;
    setFile(null);
    setStatusCC(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  useEffect(() => {
    if (isRemovingRef.current) {
      isRemovingRef.current = false;
      return;
    }

    if (file) {
      console.log("File:", file);
      handleUploadCC();
    }

    if (errorCodeCC === "ERROR") {
      setStatusCC("Upload failed validation error");
    } else if (errorCodeCC === "OK") {
      setStatusCC("");
    }
  }, [errorCodeCC, file]);

  const handleFile2Change = (e) => {
    const selectedFile2 = setFile2(e.target.files[0]);
    console.log("selectedFile2:", selectedFile2);
    if (selectedFile2) {
      setFile2(selectedFile2);
      setStatusTF(null);
    }
  };

  const removeFile2 = () => {
    isRemovingRef2.current = true;
    setFile2(null);
    setStatusTF(null);
    setLoading(false);
    if (fileInputRef2.current) {
      fileInputRef2.current.value = "";
    }
  };

  useEffect(() => {
    if (isRemovingRef2.current) {
      isRemovingRef2.current = false;
      return; // Skip status update when removing
    }

    if (file2) {
      console.log("File:", file2);
      handleUploadTF();
    }

    if (errorCodeTF === "ERROR") {
      setStatusTF("Upload failed validation error");
      setLoading(true);
    } else if (errorCodeTF === "OK") {
      console.log("Response status:", statusRes);
      setStatusTF("");
      setLoading(false);
    }
  }, [errorCodeTF, file2]);

  return (
    <>
      <h4
        style={{ textAlign: "center", marginBottom: "10px", marginTop: "30px" }}
      >
        Upload Client Card & Transaction File
      </h4>
      <hr />
      <div
        style={{
          backgroundColor: "#f3f3f3",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "10px",
        }}
      >
        <label style={{ fontWeight: "bold" }}>
          Upload Client Card (CC) <span className="text-danger">*</span>
        </label>
        <br />
        <input type="file" onChange={handleFile1Change} ref={fileInputRef} />
      </div>

      {file && (
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            marginTop: "10px",
            marginBottom: "20px",
            position: "relative",
          }}
        >
          <div>
            <p style={{ margin: "5px 0", fontWeight: "bold" }}>{file.name}</p>
            <p style={{ margin: "5px 0", color: "#555" }}>
              {(file.size / 1024).toFixed(2)} KB
            </p>
          </div>
          <button
            onClick={removeFile}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              backgroundColor: "#f44336",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "25px",
              height: "25px",
              cursor: "pointer",
            }}
          >
            &times;
          </button>
        </div>
      )}

      {statusCC && (
        <p
          style={{
            color: statusCC.includes("error")
              ? "#f44336"
              : statusCC.includes("successfully")
              ? "green"
              : "grey",
            marginTop: "-20px",
            textAlign: "center",
          }}
        >
          {statusCC}
        </p>
      )}

      <div
        style={{
          backgroundColor: "#f3f3f3",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <label style={{ fontWeight: "bold" }}>
          Upload Transaction File (TF) <span className="text-danger">*</span>
        </label>
        <br />
        <input type="file" onChange={handleFile2Change} ref={fileInputRef2} />
      </div>

      {file2 && (
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            marginTop: "10px",
            position: "relative",
          }}
        >
          <div>
            <p style={{ margin: "5px 0", fontWeight: "bold" }}>{file2.name}</p>
            <p style={{ margin: "5px 0", color: "#555" }}>
              {(file2.size / 1024).toFixed(2)} KB
            </p>
          </div>
          <button
            onClick={removeFile2}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              backgroundColor: "#f44336",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              cursor: "pointer",
            }}
          >
            &times;
          </button>
        </div>
      )}

      {statusTF && (
        <p
          style={{
            color: statusTF.includes("error")
              ? "#f44336"
              : statusTF.includes("successfully")
              ? "green"
              : "grey",
            marginTop: "5px",
            textAlign: "center",
          }}
        >
          {statusTF}
        </p>
      )}

      <button
        onClick={handleUpload}
        disabled={loading}
        className="btn btn-primary"
        style={{ marginTop: "30px" }}
      >
        {loading
          ? "Generating isheet"
          : loading === "error"
          ? "something wrong with the files"
          : "Generate iSheet"}
      </button>

      {status && (
        <p
          style={{
            backgroundColor: status.includes("error")
              ? "#7b1103"
              : status.includes("successfully")
              ? "green"
              : "grey",
            borderRadius: "10px",
            marginTop: "10px",
            padding: "10px",
            color: "#fff",
          }}
        >
          {status}
          {statusRes?.progressivekey}
        </p>
      )}
    </>
  );
};

export default FileUploadProductC;
